import { AppRoute, AuthRole } from 'common/enums/enums';

export const defaultAppRoutes = (userRoles: AuthRole[]): string => {
  if (userRoles.includes(AuthRole.Landlord)) {
    return AppRoute.LANDLORD_LISTINGS;
  } else {
    return AppRoute.ESTATES_GRID;
  }
};
